import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect, useDispatch } from 'react-redux';

import {
  catalogBibShape,
  libraryShape,
  listShape,
  userIdentityShape,
  paginationShape
} from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import {
  selectCommunityListsForCurrentBib,
  selectCommunityListsPagination
} from 'app/selectors/bibs/DiscoverySelector';
import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';

import CommunityLists from './CommunityLists';

export function CommunityListsContainer(props) {
  const dispatch = useDispatch();

  function handleListTitleClick(listId, listTitle) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'community-lists-featuring-this-title',
      ui_component_type: 'link-text',
      ui_component_label: listTitle
    };

    dispatch(
      trackContentClick({
        listId,
        ui
      })
    );
  }

  function handleListImageClick(listId) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'community-lists-featuring-this-title',
      ui_component_type: 'link-image'
    };
    dispatch(
      trackContentClick({
        listId,
        ui
      })
    );
  }

  return (
    <CommunityLists
      {...props}
      handleListTitleClick={handleListTitleClick}
      handleListImageClick={handleListImageClick}
    />
  );
}

CommunityListsContainer.propTypes = {
  library: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  pagination: paginationShape.isRequired,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  users: selectUserEntities(state),
  lists: selectCommunityListsForCurrentBib(state),
  pagination: selectCommunityListsPagination(state),
  library: selectCurrentLibrary(state)
});

export default connect(mapStateToProps)(CommunityListsContainer);
